export const IconProductLensMolecule = () => {
  return (
    <>
      <div className="w-full mt-7 lg:w-93/100 max-w-full hidden lg:block">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-full"
          viewBox="0 0 495 268.21"
        >
          <text
            id="that_enables_low-foreign_body_sensation_when_blinking."
            data-name="that enables low-foreign body sensation when blinking."
            transform="translate(348 47.084)"
            fill="#fff"
            stroke="rgba(0,0,0,0)"
            strokeWidth="1"
            className="waldo-sans font-light text-sm"
          >
            <tspan x="0" y="14">
              that enables low-foreign{' '}
            </tspan>
            <tspan x="0" y="33">
              body sensation when{' '}
            </tspan>
            <tspan x="0" y="52">
              blinking.
            </tspan>
          </text>
          <text
            id="which_mimics_the_design_of_the_eye_s_cornea_offers_outstanding_HD_vision."
            data-name="which mimics the design of the eye’s cornea, offers outstanding HD vision."
            transform="translate(342.5 164.061)"
            fill="#fff"
            stroke="rgba(0,0,0,0)"
            strokeWidth="1"
            className="waldo-sans font-light text-sm"
          >
            <tspan x="0" y="14">
              which mimics the{' '}
            </tspan>
            <tspan x="0" y="33">
              design of the eye’s{' '}
            </tspan>
            <tspan x="0" y="52">
              cornea, offers{' '}
            </tspan>
            <tspan x="0" y="71">
              outstanding HD vision.
            </tspan>
          </text>
          <line
            id="Line_238"
            data-name="Line 238"
            x2="34"
            transform="translate(302.5 36.877)"
            fill="none"
            stroke="#0057b7"
            strokeWidth="1"
          />
          <line
            id="Line_239"
            data-name="Line 239"
            x2="34"
            transform="translate(297 153.854)"
            fill="none"
            stroke="#0057b7"
            strokeWidth="1"
          />
          <text
            id="Super_fine_edge_design"
            data-name="Super fine edge"
            transform="translate(348 41.377)"
            fill="#fff"
            stroke="rgba(0,0,0,0)"
            strokeWidth="1"
            className="waldo-sans text-sm"
          >
            <tspan x="0" y="0" className="font-medium waldo-sans">
              Super fine edge
            </tspan>
          </text>
          <text
            id="Aspheric_lens_design"
            data-name="Aspheric lens design"
            transform="translate(342.5 158.354)"
            fill="#fff"
            stroke="rgba(0,0,0,0)"
            strokeWidth="1"
            className="waldo-sans text-sm"
          >
            <tspan x="0" y="0" className="font-medium waldo-sans">
              Aspheric lens design
            </tspan>
          </text>
          <text
            id="_25_x_10Dk_t_oxygen_permeability"
            data-name="25 x 10Dk/t
oxygen permeability"
            transform="translate(1 42.731)"
            fill="#fff"
            stroke="rgba(0,0,0,0)"
            strokeWidth="1"
            className="waldo-sans text-sm font-medium"
          >
            <tspan x="0" y="0">
              25 Dk/t
            </tspan>
            <tspan className="waldo-sans font-light">
              <tspan x="0" y="19">
                oxygen permeability
              </tspan>
            </tspan>
          </text>
          <text
            id="_58_moisture_content_42_Etafilcon_A"
            data-name="58% moisture content
+ 42% Etafilcon A"
            transform="translate(1 118.307)"
            fill="#fff"
            stroke="rgba(0,0,0,0)"
            strokeWidth="1"
            className="waldo-sans text-sm"
          >
            <tspan x="0" y="0" className="waldo-sans font-medium">
              58%
            </tspan>
            <tspan
              y="0"
              xmlSpace="preserve"
              className="waldo-sans font-light text-sm"
            >
              {' '}
              moisture content{' '}
            </tspan>
            <tspan className="waldo-sans font-light text-sm">
              <tspan x="0" y="19">
                +{' '}
              </tspan>
              <tspan y="19" className="waldo-sans font-medium text-sm">
                42%
              </tspan>
              <tspan y="19" xmlSpace="preserve" className="waldo-sans  text-sm">
                {' '}
                Etafilcon A
              </tspan>
            </tspan>
          </text>
          <text
            id="Class_2_classification_to_block_83_UVA_and_97_UVB_rays"
            data-name="Class 2 classification
to block 83% UVA
and 97% UVB rays"
            transform="translate(1 197.061)"
            fill="#fff"
            stroke="rgba(0,0,0,0)"
            strokeWidth="1"
            className="waldo-sans font-light text-sm"
          >
            <tspan x="0" y="0">
              Class 2 classification
            </tspan>
            <tspan x="0" y="19">
              to block{' '}
            </tspan>
            <tspan y="19" className="waldo-sans font-medium">
              83% UVA
            </tspan>
            <tspan x="0" y="38">
              and{' '}
            </tspan>
            <tspan y="38" className="waldo-sans font-medium">
              97% UVB
            </tspan>
            <tspan y="38" xmlSpace="preserve">
              {' '}
              rays
            </tspan>
          </text>
          <path
            id="Path_432"
            data-name="Path 432"
            d="M2171.029,4370.294h-16.538"
            transform="translate(-2026.491 -4324.063)"
            fill="none"
            stroke="#0057b7"
            strokeWidth="1"
          />
          <path
            id="Path_433"
            data-name="Path 433"
            d="M2187.894,4370.294h-33.4"
            transform="translate(-2026.491 -4245.309)"
            fill="none"
            stroke="#0057b7"
            strokeWidth="1"
          />
          <path
            id="Path_434"
            data-name="Path 434"
            d="M2199.618,4370.294h-45.127"
            transform="translate(-2026.491 -4159.271)"
            fill="none"
            stroke="#0057b7"
            strokeWidth="1"
          />
          <g
            id="Group_619"
            data-name="Group 619"
            transform="translate(-727 -3922.193)"
          >
            <g
              id="Group_475"
              data-name="Group 475"
              transform="translate(906.651 3937.574)"
            >
              <g
                id="Group_467"
                data-name="Group 467"
                transform="matrix(0.974, 0.225, -0.225, 0.974, 6.558, 0)"
              >
                <path
                  id="Path_360"
                  data-name="Path 360"
                  d="M0,28.969S36.165,26.644,57.794,0"
                  transform="translate(0.318 0)"
                  fill="none"
                  stroke="#0057b7"
                  strokeWidth="1"
                />
                <path
                  id="Path_361"
                  data-name="Path 361"
                  d="M0,29.021S20.916-1.011,57.771.026"
                  transform="translate(0 0.132)"
                  fill="none"
                  stroke="#0057b7"
                  strokeWidth="1"
                />
              </g>
              <g
                id="Group_470"
                data-name="Group 470"
                transform="matrix(0.974, 0.225, -0.225, 0.974, 17.18, 32.518)"
              >
                <g
                  id="Group_469"
                  data-name="Group 469"
                  transform="translate(0 0)"
                >
                  <g
                    id="Group_468"
                    data-name="Group 468"
                    transform="translate(0 0.227)"
                  >
                    <path
                      id="Path_360-2"
                      data-name="Path 360"
                      d="M0,29.861S36.24,26.443,57.861,0"
                      transform="translate(0.244 0)"
                      fill="none"
                      stroke="#0057b7"
                      strokeWidth="2"
                    />
                    <path
                      id="Path_361-2"
                      data-name="Path 361"
                      d="M0,30.121S21.65-1.012,58.505.025"
                      transform="translate(0 0)"
                      fill="none"
                      stroke="#0057b7"
                      strokeWidth="2"
                    />
                  </g>
                  <path
                    id="Path_362"
                    data-name="Path 362"
                    d="M0,0S14.559,21.943,44.163,2.715"
                    transform="translate(0.014 29.851)"
                    fill="none"
                    stroke="#0057b7"
                    strokeWidth="2"
                  />
                  <path
                    id="Path_363"
                    data-name="Path 363"
                    d="M13.98,0S21.72,17.152,0,32.575"
                    transform="translate(44.147 0)"
                    fill="none"
                    stroke="#0057b7"
                    strokeWidth="2"
                  />
                </g>
              </g>
              <g
                id="Group_472"
                data-name="Group 472"
                transform="matrix(0.974, 0.225, -0.225, 0.974, 42.412, 126.685)"
              >
                <g
                  id="Group_469-2"
                  data-name="Group 469"
                  transform="translate(0 0)"
                >
                  <g
                    id="Group_468-2"
                    data-name="Group 468"
                    transform="translate(0 0.227)"
                  >
                    <path
                      id="Path_360-3"
                      data-name="Path 360"
                      d="M0,29.861S36.24,26.443,57.861,0"
                      transform="translate(0.244 0)"
                      fill="none"
                      stroke="#0057b7"
                      strokeWidth="2"
                    />
                    <path
                      id="Path_361-3"
                      data-name="Path 361"
                      d="M0,30.121S21.65-1.012,58.505.025"
                      transform="translate(0 0)"
                      fill="none"
                      stroke="#0057b7"
                      strokeWidth="2"
                    />
                  </g>
                  <path
                    id="Path_362-2"
                    data-name="Path 362"
                    d="M0,0S14.559,21.943,44.163,2.715"
                    transform="translate(0.014 29.851)"
                    fill="none"
                    stroke="#0057b7"
                    strokeWidth="2"
                  />
                  <path
                    id="Path_363-2"
                    data-name="Path 363"
                    d="M13.98,0S21.72,17.152,0,32.575"
                    transform="translate(44.147 0)"
                    fill="none"
                    stroke="#0057b7"
                    strokeWidth="2"
                  />
                </g>
              </g>
              <g
                id="Group_474"
                data-name="Group 474"
                transform="matrix(0.974, 0.225, -0.225, 0.974, 53.071, 166.464)"
              >
                <g
                  id="Group_473"
                  data-name="Group 473"
                  transform="translate(0 0)"
                >
                  <g
                    id="Group_469-3"
                    data-name="Group 469"
                    transform="translate(0 0)"
                  >
                    <g
                      id="Group_468-3"
                      data-name="Group 468"
                      transform="translate(0.373 0.403)"
                    >
                      <path
                        id="Path_360-4"
                        data-name="Path 360"
                        d="M0,29.663S36.115,26.443,57.735,0"
                        transform="translate(0 0)"
                        fill="none"
                        stroke="#0057b7"
                        strokeWidth="1"
                      />
                    </g>
                    <path
                      id="Path_362-3"
                      data-name="Path 362"
                      d="M0,0S14.559,21.943,44.163,2.715"
                      transform="translate(0 29.851)"
                      fill="none"
                      stroke="#0057b7"
                      strokeWidth="1"
                    />
                    <path
                      id="Path_363-3"
                      data-name="Path 363"
                      d="M13.98,0S21.72,17.152,0,32.575"
                      transform="translate(44.132 0)"
                      fill="none"
                      stroke="#0057b7"
                      strokeWidth="1"
                    />
                  </g>
                </g>
              </g>
              <g
                id="Group_471"
                data-name="Group 471"
                transform="matrix(0.974, 0.225, -0.225, 0.974, 30.121, 80.812)"
              >
                <g
                  id="Group_469-4"
                  data-name="Group 469"
                  transform="translate(0 0)"
                >
                  <g
                    id="Group_468-4"
                    data-name="Group 468"
                    transform="translate(0 0.227)"
                  >
                    <path
                      id="Path_360-5"
                      data-name="Path 360"
                      d="M0,29.861S36.24,26.443,57.861,0"
                      transform="translate(0.244 0)"
                      fill="none"
                      stroke="#fff"
                      strokeWidth="1"
                    />
                    <path
                      id="Path_361-4"
                      data-name="Path 361"
                      d="M0,30.121S21.65-1.012,58.505.025"
                      transform="translate(0 0)"
                      fill="none"
                      stroke="#fff"
                      strokeWidth="1"
                    />
                  </g>
                  <path
                    id="Path_362-4"
                    data-name="Path 362"
                    d="M0,0S14.559,21.943,44.163,2.715"
                    transform="translate(0.014 29.851)"
                    fill="none"
                    stroke="#fff"
                    strokeWidth="1"
                  />
                  <path
                    id="Path_363-4"
                    data-name="Path 363"
                    d="M13.98,0S21.72,17.152,0,32.575"
                    transform="translate(44.147 0)"
                    fill="none"
                    stroke="#fff"
                    strokeWidth="1"
                  />
                </g>
              </g>
            </g>
            <path
              id="Path_373"
              data-name="Path 373"
              d="M0,0V277.136"
              transform="matrix(0.966, -0.259, 0.259, 0.966, 931.411, 3922.452)"
              fill="none"
              stroke="#fff"
              strokeWidth="1"
              strokeDasharray="1"
            />
            <path
              id="Path_374"
              data-name="Path 374"
              d="M0,0V277.136"
              transform="matrix(0.966, -0.259, 0.259, 0.966, 965.11, 3922.452)"
              fill="none"
              stroke="#fe5000"
              strokeWidth="2"
              strokeDasharray="1"
            />
            <path
              id="Path_375"
              data-name="Path 375"
              d="M0,0V277.136"
              transform="matrix(0.966, -0.259, 0.259, 0.966, 895, 3922.452)"
              fill="none"
              stroke="#fe5000"
              strokeWidth="2"
              strokeDasharray="1"
            />
          </g>
        </svg>
      </div>
      <div className="mt-7 w-full mb-5 mx-auto block lg:hidden">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-full"
          viewBox="0 0 342.5 309.614"
        >
          <text
            id="that_enables_low-_foreign_body_sensation_when_blinking."
            data-name="that enables low- foreign body sensation when blinking."
            transform="translate(244.5 65.307)"
            fill="#fff"
            className="waldo-sans font-light text-xs"
          >
            <tspan x="0" y="12">
              that enables low-{' '}
            </tspan>
            <tspan x="0" y="28">
              foreign body{' '}
            </tspan>
            <tspan x="0" y="44">
              sensation when{' '}
            </tspan>
            <tspan x="0" y="60">
              blinking.
            </tspan>
          </text>
          <text
            id="which_mimics_the_design_of_the_eye_s_cornea_offers_outstanding_HD_vision."
            data-name="which mimics the design of the eye’s cornea, offers outstanding HD vision."
            transform="translate(244.5 184.22)"
            fill="#fff"
            className="waldo-sans font-light text-xs"
          >
            <tspan x="0" y="12">
              which mimics the{' '}
            </tspan>
            <tspan x="0" y="28">
              design of the eye’s{' '}
            </tspan>
            <tspan x="0" y="44">
              cornea, offers{' '}
            </tspan>
            <tspan x="0" y="60">
              outstanding HD{' '}
            </tspan>
            <tspan x="0" y="76">
              vision.
            </tspan>
          </text>
          <line
            id="Line_190"
            data-name="Line 190"
            x2="34"
            transform="translate(196.5 44.644)"
            fill="none"
            stroke="#0057b7"
            strokeWidth="1"
          />
          <line
            id="Line_220"
            data-name="Line 220"
            x2="12"
            transform="translate(218.5 164.22)"
            fill="none"
            stroke="#0057b7"
            strokeWidth="1"
          />
          <g
            id="Group_475"
            data-name="Group 475"
            transform="translate(-11.743 -5923.693)"
          >
            <g
              id="Group_467"
              data-name="Group 467"
              transform="matrix(0.974, 0.225, -0.225, 0.974, 1363.547, 124.438)"
            >
              <path
                id="Path_360"
                data-name="Path 360"
                d="M2165.611,4376.223s41.759-2.686,66.733-33.45"
                transform="translate(-2068 1614)"
                fill="none"
                stroke="#0057b7"
                strokeWidth="1"
              />
              <path
                id="Path_361"
                data-name="Path 361"
                d="M2165.611,4376.584s24.151-34.676,66.707-33.479"
                transform="translate(-2068.368 1613.85)"
                fill="none"
                stroke="#0057b7"
                strokeWidth="1"
              />
            </g>
            <g
              id="Group_470"
              data-name="Group 470"
              transform="matrix(0.974, 0.225, -0.225, 0.974, 1387.223, 103.744)"
            >
              <g
                id="Group_469"
                data-name="Group 469"
                transform="translate(-18 19.316)"
              >
                <g
                  id="Group_468"
                  data-name="Group 468"
                  transform="translate(20 40)"
                >
                  <path
                    id="Path_360-2"
                    data-name="Path 360"
                    d="M2165.508,4377.252s41.845-3.947,66.81-34.479"
                    transform="translate(-2068 1614.262)"
                    fill="none"
                    stroke="#0057b7"
                    strokeWidth="2"
                  />
                  <path
                    id="Path_361-2"
                    data-name="Path 361"
                    d="M2165.594,4377.965s25-35.948,67.554-34.751"
                    transform="translate(-2068.368 1613.85)"
                    fill="none"
                    stroke="#0057b7"
                    strokeWidth="2"
                  />
                </g>
                <path
                  id="Path_362"
                  data-name="Path 362"
                  d="M2185.243,4417.24s16.81,25.336,50.994,3.135"
                  transform="translate(-2068 1614)"
                  fill="none"
                  stroke="#0057b7"
                  strokeWidth="2"
                />
                <path
                  id="Path_363"
                  data-name="Path 363"
                  d="M2252.344,4382.772s8.938,19.8-16.142,37.613"
                  transform="translate(-2068 1614)"
                  fill="none"
                  stroke="#0057b7"
                  strokeWidth="2"
                />
              </g>
            </g>
            <g
              id="Group_472"
              data-name="Group 472"
              transform="matrix(0.974, 0.225, -0.225, 0.974, 1416.357, 212.475)"
            >
              <g
                id="Group_469-2"
                data-name="Group 469"
                transform="translate(-18 19.316)"
              >
                <g
                  id="Group_468-2"
                  data-name="Group 468"
                  transform="translate(20 40)"
                >
                  <path
                    id="Path_360-3"
                    data-name="Path 360"
                    d="M2165.508,4377.252s41.845-3.947,66.81-34.479"
                    transform="translate(-2068 1614.262)"
                    fill="none"
                    stroke="#0057b7"
                    strokeWidth="2"
                  />
                  <path
                    id="Path_361-3"
                    data-name="Path 361"
                    d="M2165.594,4377.965s25-35.948,67.554-34.751"
                    transform="translate(-2068.368 1613.85)"
                    fill="none"
                    stroke="#0057b7"
                    strokeWidth="2"
                  />
                </g>
                <path
                  id="Path_362-2"
                  data-name="Path 362"
                  d="M2185.243,4417.24s16.81,25.336,50.994,3.135"
                  transform="translate(-2068 1614)"
                  fill="none"
                  stroke="#0057b7"
                  strokeWidth="2"
                />
                <path
                  id="Path_363-2"
                  data-name="Path 363"
                  d="M2252.344,4382.772s8.938,19.8-16.142,37.613"
                  transform="translate(-2068 1614)"
                  fill="none"
                  stroke="#0057b7"
                  strokeWidth="2"
                />
              </g>
            </g>
            <g
              id="Group_474"
              data-name="Group 474"
              transform="matrix(0.974, 0.225, -0.225, 0.974, 1371.788, 113.496)"
            >
              <g
                id="Group_473"
                data-name="Group 473"
                transform="translate(88 128.402)"
              >
                <g
                  id="Group_469-3"
                  data-name="Group 469"
                  transform="translate(-18 19.316)"
                >
                  <g
                    id="Group_468-3"
                    data-name="Group 468"
                    transform="translate(20 40)"
                  >
                    <path
                      id="Path_360-4"
                      data-name="Path 360"
                      d="M2165.673,4377.227s41.7-3.718,66.665-34.25"
                      transform="translate(-2068 1614.262)"
                      fill="none"
                      stroke="#0057b7"
                      strokeWidth="1"
                    />
                  </g>
                  <path
                    id="Path_362-3"
                    data-name="Path 362"
                    d="M2185.243,4417.24s16.81,25.336,50.994,3.135"
                    transform="translate(-2068 1614)"
                    fill="none"
                    stroke="#0057b7"
                    strokeWidth="1"
                  />
                  <path
                    id="Path_363-3"
                    data-name="Path 363"
                    d="M2252.344,4382.772s8.938,19.8-16.142,37.613"
                    transform="translate(-2068 1614)"
                    fill="none"
                    stroke="#0057b7"
                    strokeWidth="1"
                  />
                </g>
              </g>
            </g>
            <g
              id="Group_471"
              data-name="Group 471"
              transform="matrix(0.974, 0.225, -0.225, 0.974, 1402.165, 159.507)"
            >
              <g
                id="Group_469-4"
                data-name="Group 469"
                transform="translate(-18 19.316)"
              >
                <g
                  id="Group_468-4"
                  data-name="Group 468"
                  transform="translate(20 40)"
                >
                  <path
                    id="Path_360-5"
                    data-name="Path 360"
                    d="M2165.508,4377.252s41.845-3.947,66.81-34.479"
                    transform="translate(-2068 1614.262)"
                    fill="none"
                    stroke="#fff"
                    strokeWidth="1"
                  />
                  <path
                    id="Path_361-4"
                    data-name="Path 361"
                    d="M2165.594,4377.965s25-35.948,67.554-34.751"
                    transform="translate(-2068.368 1613.85)"
                    fill="none"
                    stroke="#fff"
                    strokeWidth="1"
                  />
                </g>
                <path
                  id="Path_362-4"
                  data-name="Path 362"
                  d="M2185.243,4417.24s16.81,25.336,50.994,3.135"
                  transform="translate(-2068 1614)"
                  fill="none"
                  stroke="#fff"
                  strokeWidth="1"
                />
                <path
                  id="Path_363-4"
                  data-name="Path 363"
                  d="M2252.344,4382.772s8.938,19.8-16.142,37.613"
                  transform="translate(-2068 1614)"
                  fill="none"
                  stroke="#fff"
                  strokeWidth="1"
                />
              </g>
            </g>
          </g>
          <text
            id="Super_fine_edge_design"
            data-name="Super fine
edge"
            transform="translate(244.5 41.807)"
            fill="#fff"
            className="waldo-sans text-xs font-medium"
          >
            <tspan x="0" y="0">
              Super fine
            </tspan>
            <tspan x="0" y="16">
              edge
            </tspan>
          </text>
          <text
            id="Aspheric_lens_design"
            data-name="Aspheric lens
design"
            transform="translate(244.5 160.72)"
            fill="#fff"
            className="waldo-sans text-xs font-medium"
          >
            <tspan x="0" y="0">
              Aspheric lens
            </tspan>
            <tspan x="0" y="16">
              design
            </tspan>
          </text>
          <text
            id="_25_x_10Dk_t_oxygen_permeability"
            data-name="25 x 10Dk/t
oxygen
permeability"
            transform="translate(0 46.72)"
            fill="#fff"
            className="waldo-sans text-xs"
          >
            <tspan x="0" y="0" className="font-medium waldo-sands">
              25 Dk/t
            </tspan>
            <tspan className="waldo-sans font-light">
              <tspan x="0" y="16">
                oxygen
              </tspan>
              <tspan x="0" y="32">
                permeability
              </tspan>
            </tspan>
          </text>
          <text
            id="_58_moisture_content_42_Etafilcon_A"
            data-name="58% moisture
content + 42%
Etafilcon A"
            transform="translate(0 125.72)"
            fill="#fff"
            className="waldo-sans text-xs"
          >
            <tspan x="0" y="0" className="font-medium waldo-sands">
              58%{' '}
            </tspan>
            <tspan y="0" className="waldo-sans font-light">
              moisture
            </tspan>
            <tspan className="waldo-sans font-light">
              <tspan x="0" y="16">
                content +{' '}
              </tspan>
              <tspan x="0" y="32" className="waldo-sans font-medium">
                42%{' '}
              </tspan>
              <tspan y="32">Etafilcon A</tspan>
            </tspan>
          </text>
          <text
            id="Class_2_classification_to_block_83_UVA_and_97_UVB_rays"
            data-name="Class 2
classification
to block 83% UVA
and 97% UVB rays"
            transform="translate(0 211.72)"
            fill="#fff"
            fontSize="12"
            className="waldo-sans font-light"
          >
            <tspan x="0" y="0">
              Class 2
            </tspan>
            <tspan x="0" y="16">
              classification
            </tspan>
            <tspan x="0" y="32">
              to block{' '}
            </tspan>
            <tspan y="32" className="waldo-sans font-medium">
              83% UVA
            </tspan>
            <tspan x="0" y="48">
              and{' '}
            </tspan>
            <tspan y="48" className="waldo-sans font-medium">
              97% UVB
            </tspan>
            <tspan y="48"> </tspan>
            <tspan y="48" className="waldo-sans font-medium">
              rays
            </tspan>
          </text>
          <path
            id="Path_364"
            data-name="Path 364"
            d="M2170.3,4370.294h-15.806"
            transform="translate(-2082.298 -4308.199)"
            fill="none"
            stroke="#0057b7"
            strokeWidth="1"
          />
          <path
            id="Path_365"
            data-name="Path 365"
            d="M2182.434,4370.294h-27.942"
            transform="translate(-2077.029 -4230.612)"
            fill="none"
            stroke="#0057b7"
            strokeWidth="1"
          />
          <path
            id="Path_366"
            data-name="Path 366"
            d="M2203.986,4370.294h-49.5"
            transform="translate(-2077.029 -4144.612)"
            fill="none"
            stroke="#0057b7"
            strokeWidth="1"
          />
          <path
            id="Path_373"
            data-name="Path 373"
            d="M0,0V320"
            transform="matrix(0.966, -0.259, 0.259, 0.966, 127.589, 0.259)"
            fill="none"
            stroke="#fff"
            strokeWidth="1"
            strokeDasharray="1"
          />
          <path
            id="Path_374"
            data-name="Path 374"
            d="M0,0V320"
            transform="matrix(0.966, -0.259, 0.259, 0.966, 166.5, 0.259)"
            fill="none"
            stroke="#fe5000"
            strokeWidth="2"
            strokeDasharray="1"
          />
          <path
            id="Path_375"
            data-name="Path 375"
            d="M0,0V320"
            transform="matrix(0.966, -0.259, 0.259, 0.966, 85.546, 0.259)"
            fill="none"
            stroke="#fe5000"
            strokeWidth="2"
            strokeDasharray="1"
          />
        </svg>
      </div>
    </>
  );
};
